export enum FetchListType {
  whitelist = 'whitelist',
  dataservices = 'dataservices',
  careproviders = 'careproviders',
}
